import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector: "[phone][formControlName],[phone][formControl],[phone][ngModel]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PhoneValidator),
      multi: true,
    },
  ],
})
export class PhoneValidator implements Validator {
  constructor(@Attribute("phone") public phone?: string) {}

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let v = c.value;

    // value not equal
    if (v && !this.isPhoneValid(v)) {
      return {
        phone: false,
      };
    }

    return null;
  }

  isPhoneValid(phone: any) {
    var re =
      /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
    return re.test(phone);
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/phone.validator.ts